(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-footer"] && !Shopify.designMode) return;
  try {
    
  /* Las columnas del footer van con `open` en el HTML para que sin JS se vean
     enteras. Aqui solo se cierran cuando la pantalla es de movil, y se vuelven a
     abrir al pasar a escritorio (si no, quedarian colapsadas al girar el movil o
     al agrandar la ventana). */
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');

    function ajustar() {
      var cols = document.querySelectorAll('details.phf__col');
      for (var i = 0; i < cols.length; i++) {
        cols[i].open = !mq.matches;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ajustar);
    } else {
      ajustar();
    }

    /* addEventListener en MediaQueryList no existe en Safari antiguos. */
    if (mq.addEventListener) {
      mq.addEventListener('change', ajustar);
    } else if (mq.addListener) {
      mq.addListener(ajustar);
    }

    document.addEventListener('shopify:section:load', ajustar);
  })();

  } catch(e) { console.error(e); }
})();
})();
